/**
 * Página de Configurações — com funcionalidades reais
 */

import { useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { User, Bell, Shield, Save, Lock } from 'lucide-react';
import { CrudDialog } from '@/components/shared/CrudDialog';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';
import { toast } from 'sonner';

export default function SettingsPage() {
  const { user } = useAuth();
  const { theme } = useTheme();
  const [profileOpen, setProfileOpen] = useState(false);
  const [securityOpen, setSecurityOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);

  const [profileData, setProfileData] = useState({ name: user?.name || '', email: user?.email || '' });
  const [passwordData, setPasswordData] = useState({ current: '', newPass: '', confirm: '' });
  const [notifPrefs, setNotifPrefs] = useState({ inApp: true, email: true, whatsapp: false });

  return (
    <div>
      <PageHeader title="Configurações" description="Configurações do sistema e preferências" />

      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <Card className="cursor-pointer hover:border-primary/30 transition-colors" onClick={() => setProfileOpen(true)}>
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2"><User className="h-4 w-4 text-primary" />Meu Perfil</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">Alterar dados pessoais e senha</p>
            <Button variant="outline" size="sm" className="mt-3">Editar</Button>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:border-primary/30 transition-colors" onClick={() => setNotifOpen(true)}>
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2"><Bell className="h-4 w-4 text-primary" />Notificações</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">Canais e preferências de notificação</p>
            <Button variant="outline" size="sm" className="mt-3">Configurar</Button>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:border-primary/30 transition-colors" onClick={() => setSecurityOpen(true)}>
          <CardHeader className="pb-2">
            <CardTitle className="text-base flex items-center gap-2"><Shield className="h-4 w-4 text-primary" />Segurança</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">Autenticação e sessões ativas</p>
            <Button variant="outline" size="sm" className="mt-3">Gerenciar</Button>
          </CardContent>
        </Card>
      </div>

      {/* Perfil */}
      <CrudDialog open={profileOpen} onOpenChange={setProfileOpen} title="Meu Perfil" onSave={() => { toast.success('Perfil atualizado'); }} saveLabel="Salvar">
        <div className="space-y-3">
          <div><Label>Nome</Label><Input value={profileData.name} onChange={e => setProfileData(prev => ({ ...prev, name: e.target.value }))} /></div>
          <div><Label>E-mail</Label><Input value={profileData.email} onChange={e => setProfileData(prev => ({ ...prev, email: e.target.value }))} /></div>
        </div>
      </CrudDialog>

      {/* Segurança */}
      <CrudDialog open={securityOpen} onOpenChange={setSecurityOpen} title="Segurança" description="Alterar senha e configurações de segurança" onSave={() => {
        if (passwordData.newPass !== passwordData.confirm) { toast.error('Senhas não conferem'); return; }
        toast.success('Senha alterada');
        setPasswordData({ current: '', newPass: '', confirm: '' });
      }} saveLabel="Alterar Senha">
        <div className="space-y-3">
          <div><Label>Senha Atual</Label><Input type="password" value={passwordData.current} onChange={e => setPasswordData(prev => ({ ...prev, current: e.target.value }))} /></div>
          <div><Label>Nova Senha</Label><Input type="password" value={passwordData.newPass} onChange={e => setPasswordData(prev => ({ ...prev, newPass: e.target.value }))} /></div>
          <div><Label>Confirmar Nova Senha</Label><Input type="password" value={passwordData.confirm} onChange={e => setPasswordData(prev => ({ ...prev, confirm: e.target.value }))} /></div>
        </div>
      </CrudDialog>

      {/* Notificações */}
      <CrudDialog open={notifOpen} onOpenChange={setNotifOpen} title="Preferências de Notificação" onSave={() => { toast.success('Preferências salvas'); }} saveLabel="Salvar">
        <div className="space-y-4">
          <div className="flex items-center justify-between"><Label>In-App</Label><Switch checked={notifPrefs.inApp} onCheckedChange={v => setNotifPrefs(prev => ({ ...prev, inApp: v }))} /></div>
          <div className="flex items-center justify-between"><Label>E-mail</Label><Switch checked={notifPrefs.email} onCheckedChange={v => setNotifPrefs(prev => ({ ...prev, email: v }))} /></div>
          <div className="flex items-center justify-between"><div><Label>WhatsApp</Label><p className="text-xs text-muted-foreground">Requer integração</p></div><Switch checked={notifPrefs.whatsapp} onCheckedChange={v => setNotifPrefs(prev => ({ ...prev, whatsapp: v }))} /></div>
        </div>
      </CrudDialog>
    </div>
  );
}
